import React from "react";
import { useTranslation } from "react-i18next";
import { externalLinks } from "helpers/constant";

import motorBlackIcon from "assets/svg/claims/motor-black-icon.svg";
import healthBlackIcon from "assets/svg/claims/health-black-icon.svg";
import travelBlackIcon from "assets/svg/claims/travel-black-icon.svg";
import thirdPartyBlackIcon from "assets/svg/claims/third-party-black-icon.svg";
import medMalBlackIcon from "assets/svg/claims/MedMal-black-icon.svg";

import "./submitClaimsCards.scss";

const SubmitClaimsCards = ({ calLem, TrackEvent, TrackEventWithProduct, className = "" }) => {
  const { t } = useTranslation();

  const CLAIM_CARDS = [
    {
      id: "vehicle-insurance",
      titleKey: "claimsPage.vehicleInsurance.title",
      subtitleKey: "claimsPage.vehicleInsurance.subtitle",
      icon: motorBlackIcon,
      redirectUrl: `${externalLinks.common}tp-claims`,
      eventKey: "tp-claimsTabClicked",
      openInNewTab: true,
    },
    {
      id: "motor-individual",
      titleKey: "claimsPage.motorIndividual.title",
      subtitleKey: "claimsPage.motorIndividual.subtitle",
      icon: motorBlackIcon,
      redirectUrl: "https://www.tawuniya.com/login",
      eventKey: "co-claimsTabClicked",
      openInNewTab: false
    },
    {
      id: "health-insurance",
      titleKey: "claimsPage.healthInsurance.title",
      subtitleKey: "claimsPage.healthInsurance.subtitle",
      icon: healthBlackIcon,
      redirectUrl: "https://www.tawuniya.com/en/login",
      eventKey: "health-claimsTabClicked",
      openInNewTab: false
    },
    {
      id: "motor-corporate",
      titleKey: "claimsPage.motorCorporate.title",
      subtitleKey: "claimsPage.motorCorporate.subtitle",
      icon: motorBlackIcon,
      redirectUrl: "https://www.tawuniya.com/cxp-pxp/motor-claim/business-details",
      eventKey: "co-claimsTabClicked",
      openInNewTab: false
    },
    {
      id: "travel-insurance",
      titleKey: "claimsPage.travelInsurance.title",
      subtitleKey: "claimsPage.travelInsurance.subtitle",
      icon: travelBlackIcon,
      redirectUrl: "https://www.tawuniya.com/en/login",
      eventKey: "travel-claimsTabClicked",
      openInNewTab: false
    },
    {
      id: "third-party",
      titleKey: "claimsPage.thirdParty.title",
      subtitleKey: "claimsPage.thirdParty.subtitle",
      icon: thirdPartyBlackIcon,
      redirectUrl: `${externalLinks.common}tp-claims`,
      eventKey: "tp-claimsTabClicked",
      openInNewTab: true
    },
    {
      id: "medical-malpractice",
      titleKey: "claimsPage.medicalMalpractice.title",
      subtitleKey: "claimsPage.medicalMalpractice.subtitle",
      icon: medMalBlackIcon,
      redirectUrl: "https://www.tawuniya.com/en/login",
      eventKey: "medMal-claimsTabClicked",
      openInNewTab: false
    },
  ];

  const handleCardClick = (card) => {
    if (typeof TrackEventWithProduct === "function") {
      TrackEventWithProduct(card.eventKey, "Claims");
    } else if (typeof TrackEvent === "function") {
      TrackEvent(card.eventKey);
    }

    if (typeof calLem === "function") {
      calLem(card.redirectUrl);
    }

    if (card.redirectUrl) {
      card.openInNewTab
        ? window.open(card.redirectUrl, "_blank", "noopener,noreferrer")
        : window.location.assign(card.redirectUrl);
    }
  };

  return (
    <div className={`submit-claims-panel ${className}`}>
      <div className="panel-header">
        <h2 className="panel-title">{t("claimsPage.submitNewClaims")}</h2>
        <p className="panel-subtitle">{t("claimsPage.subtitle")}</p>
      </div>

      <div className="cards-grid">
        {CLAIM_CARDS.map((card) => (
          <div
            key={card.id}
            className="claim-card-item"
            onClick={() => handleCardClick(card)}
          >
            <img src={card.icon} alt={t(card.titleKey)} className="card-icon" />
            <div className="card-text-wrapper">
              <div className="card-title">{t(card.titleKey)}</div>
              <div className="card-subtitle">{t(card.subtitleKey)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubmitClaimsCards;